import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ru',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "https://translate.googleapis.com/translate_a/single?client=gtx&sl={{lng}}&tl={{lng}}&dt=t&q={{text}}",
    },
  });

export default i18n;
